import { collectionDoc } from "../../collectionRef/collectionOperations";

export async function _getUserBasedOnUid(uid: string) {
  const _profile = await collectionDoc.profiles(uid);
  const profile = _profile.data();
  return profile;
}
